import { ProjectListWithGenerationSummary } from '../types'
import { formatPower, formatEnergy } from '../features/energy/utils'

interface ProjectSummaryProps {
    projectsSummary: ProjectListWithGenerationSummary
}

function ProjectSummary({ projectsSummary }: ProjectSummaryProps) {
    const totalGenerationKw = projectsSummary.instances.reduce((acc, project) => acc + project.total_generation_kw, 0);
    const totalStorageCapacityKwh = projectsSummary.instances.reduce((acc, project) => acc + project.total_storage_capacity_kwh, 0);
    let pvGenerationTotal = 0, batteryThroughput = 0;
    try {
        pvGenerationTotal = projectsSummary.results["EnergyAndPowerPv"]["pvGeneration"];
    } catch (error) {
        pvGenerationTotal = 0;
    }
    try {
        batteryThroughput = projectsSummary.results["EnergyAndPowerBattery"]["batteryCharging"] + projectsSummary.results["EnergyAndPowerBattery"]["batteryDischarging"];
    } catch (error) {
        batteryThroughput = 0;
    }

    return (
        <div className="rounded-lg bg-pacificblue-700 mb-4 p-3 grid grid-cols-3 gap-4">
            <div className='flex flex-col'>
                <div className='mb-3 text-2xl text-white'>
                    <span className='opacity-75 font-bold me-3'>Solar PV</span>
                    <span className='font-bold'>{formatPower(totalGenerationKw)}</span>
                </div>
                <div className='text-lg text-white font-bold'>
                    <span className='opacity-75 me-3'>Generation</span>
                    <span>{formatEnergy(pvGenerationTotal)}</span>
                </div>
                <div className='text-lg text-white font-bold'>
                    <span className='opacity-75 me-3'>Yield</span>
                    <span>— MWh/MWp</span>
                </div>
            </div>
            <div className='flex flex-col'>
                <div className='mb-3 text-2xl text-white font-bold'>
                    <span className='opacity-75 me-3'>BESS</span>
                    <span>{formatEnergy(totalStorageCapacityKwh)}</span>
                </div>
                <div className='text-lg text-white font-bold'>
                    <span className='opacity-75 me-3'>Throughput</span>
                    <span>{formatEnergy(batteryThroughput)}</span>
                </div>
            </div>
            <div className='flex flex-col'>
                <div className='mb-3 text-2xl text-white font-bold'>
                    <span className='opacity-75 me-3'>Hydro</span>
                    <span>{0} MWh</span>
                </div>
                <div className='text-lg text-white font-bold'>
                    <span className='opacity-75 me-3'>Generation</span>
                    <span>{0} MWh</span>
                </div>
            </div>
        </div>
    )
}

export default ProjectSummary;